import styled from 'styled-components'

export const InvoiceExportWrapper = styled.div`
  th {
    text-align: center;
  }
  .SearchAndFilters { margin-left: 65px },
`
